import { LogOutButton } from 'components/LogOutButton'
import { A } from 'hookrouter'
import React, { FC } from 'react'
import { Navbar } from 'react-bootstrap'
import { Logo } from 'components/Logo'
import { UrlParams } from 'types'
import { ActiveCompanyNavSelector } from '../ActiveCompanyNavSelector'
import { ActiveProjectNavSelector } from '../ActiveProjectNavSelector'
import { UserHeaderDisplay } from '../UserHeaderDisplay'

export const Header: FC<UrlParams> = ({ companyId, projectId }) => {
  
  return (
    <Navbar expand="lg">
      <Navbar.Brand as={A} href="/">
        <Logo />
      </Navbar.Brand>
      <Navbar.Toggle />

      <Navbar.Collapse>
        <div className="nav-items-wrap">
          <ActiveCompanyNavSelector companyId={companyId} />
          <ActiveProjectNavSelector
            projectId={projectId}
            companyId={companyId}
          />
          <div className="user-status">
            <UserHeaderDisplay />
            <LogOutButton />
          </div>
        </div>
      </Navbar.Collapse>
    </Navbar>
  )
}
